var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolBox',{attrs:{"title":'画图工具'},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('DrawTypeScope')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }